/**
 * The browser tab's title: the page first, then Sparrow ("Stats · Sparrow"), so the part
 * that says where you are survives when a tab or the app switcher cuts it short. Today, the
 * home page, is just "Sparrow". A trailing full stop is dropped ("Couldn't load today's
 * Sparrow." → "Couldn't load today's Sparrow · Sparrow").
 */
export const SITE_NAME = 'Sparrow';

export function pageTitle(page?: string | null): string {
	const name = page?.trim().replace(/\.$/, '');
	return name ? `${name} · ${SITE_NAME}` : SITE_NAME;
}

/** Sets the tab's title (see `pageTitle`). */
export function setPageTitle(page?: string | null): void {
	if (typeof document !== 'undefined') document.title = pageTitle(page);
}
